class Proposta {
    constructor(
        public id = 0,
        public idEscola = 0,
        public escola = "",
        public inici = new Date(),
        public fin = new Date(),
        public estat = 0,
        public creacio = new Date(),
        public comentaris = "",
        public qI = 0,
        public qP = 0,
        public qA = 0
    ) {
        this.id = id;
        this.idEscola = idEscola;
        this.escola = escola;
        this.inici = inici;
        this.fin = fin;
        this.estat = estat;
        this.creacio = creacio;
        this.comentaris = comentaris;
        this.qI = qI;
        this.qP = qP;
        this.qA = qA;
    }
}

export default Proposta;
